<template>
  <date-from-to
    label="Activation Dates"
    :value="{
      from: value.flightStartDate,
      to: value.flightEndDate
    }"
    :fromNotBeforeDate="startingFromDate"
    @input="val => modifyDates(val)"
    :disableFrom="startDateDisable"
    :disableTo="endDateDisable"
    startToDateFromToday
    :optionSetting="4"
  />
</template>

<script>
import DateFromTo from '@/components/common/dateRange/DateFromTo'
import { ATT_STATUS } from '@/appLogic/targets/Constants'
import {isAtLeastDaysOld} from '@/common/U_D'

export default {
  components: {
    DateFromTo
  },
  props: {
    value: {
      flightStartDate: {
        type: Date,
        default: null
      },
      flightEndDate: {
        type: Date,
        default: null
      },
      AEFlightEndDate: {// this is returned but never used in the component itself, it is 14 days from End Date
        type: Date,
        default: null
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    startIsInFuture: {
      type: Boolean,
      default: false
    },
    endIsInFuture: {
      type: Boolean,
      default: false
    },
    endIsWithin45Days: {
      type: Boolean,
      default: false
    },
    attStatus: {
      type: String,
      default: undefined
    },
    submittionDate: {
      type: Date,
      default: undefined
    },
    isSubmitted: {
      type: Boolean,
      default: false
    },
    isLive: {
      type: Boolean,
      default: false
    },
    isWorking: {
      type: Boolean,
      default: false
    },
    isActivatedStatus: {
      type: Boolean,
      default: false
    },
    originalFlightEndDate: {
      type: Date,
      default: null
    }
  },
  computed: {
    isPlanned () {
      return this.isNew ? true : this.attStatus === ATT_STATUS.PLANNING
    },
    isNew () {
      return !this.attStatus
    },
    isOrdered () {
      return this.attStatus === ATT_STATUS.ORDERED
    },
    startingFromDate () {
      const nextDay = new Date()
      nextDay.setDate(nextDay.getDate() + 1)
      return nextDay
    },
    submittedAtLeastOneDayAgo () {
      if (this.submittionDate) {
        const DAYS_OLD = 1
        return this.submittionDate ? isAtLeastDaysOld(this.submittionDate, DAYS_OLD) : null
      } else {
        return false
      }
    },
    startDateDisable () {
      return this.disableStartDate || this.disabled
    },
    disableStartDate () {
      if (!this.attStatus) {
        if (this.isActivatedStatus || this.isWorking) {
          return false
        } else if ((this.isSubmitted || this.isLive) && !this.startIsInFuture) {
          return true
        }
      } else if (this.isPlanned) {
        if (this.isNew) {
          return false
        } else {
          if (this.submittedAtLeastOneDayAgo) {
            if (this.value.flightStartDate) {
              return !this.beforeStartFlightDate
            } else {
              return false
            }
          } else {
            return false
          }
        }
      } else if (this.isOrdered) {
        if (this.beforeStartFlightDate) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    beforeStartFlightDate () {
      if (this.isNew) {
        return true
      } else {
        const today = new Date()
        return this.value.flightStartDate ? this.value.flightStartDate > today : false
      }
    },
    endDateDisable () {
      return this.disableEndDate || this.disabled
    },
    disableEndDate () {
      if (!this.attStatus) {
        if (this.isActivatedStatus || this.isWorking) {
          return false
        } else if ((this.isSubmitted || this.isLive) && !(this.endIsInFuture || (!this.endIsInFuture && this.endIsWithin45Days))) {
          return true
        }
      } else if (this.isOrdered || this.isPlanned) {
        return !(this.beforeEndFlightDate || (!this.endIsInFuture && this.endIsWithin45Days))
      } else {
        return true
      }
    },
    beforeEndFlightDate () {
      if (this.isNew) {
        return true
      } else {
        const today = new Date()
        if (!this.originalFlightEndDate) {
          return true
        }
        return this.originalFlightEndDate ? this.originalFlightEndDate > today : false
      }
    },
    isDisabled () {
      return this.startDateDisable && this.endDateDisable
    }
  },
  methods: {
    modifyDates (val) {
      this.$emit('input', {
        flightStartDate: val.from,
        flightEndDate: val.to,
        AEFlightEndDate: val.to,
      })
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// FlightDates.vue?3ad1bd77